import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CompteState {
  confirmationCreationCompte?: boolean;
}

const initialState: CompteState = {
  confirmationCreationCompte: false,
};

export const CompteSlice = createSlice({
  name: "@@app/compte",
  initialState: initialState,
  reducers: {
    setConfirmationCreationCompte: (
      state: CompteState,
      action: PayloadAction<boolean>
    ) => {
      state.confirmationCreationCompte = action.payload;
    },
  },
});

export const { setConfirmationCreationCompte } = CompteSlice.actions;

// Selectors
export const getConfirmationCreationCompte = (state): boolean =>
  state.compte && state.compte.confirmationCreationCompte;
